import { Map, List } from 'immutable'
import { groupList } from './group-list'
import { getAuth } from '../auth'
import { firebaseDb } from '../firebase';
import { getDeletedGroup } from './selectors';
import {
  getStudentsStagedForInvite,
  getStudentsStagedForInviteByEmail } from './selectors'
import {
  CREATE_GROUP_ERROR,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_CONFLICT,
  CREATE_SINGLE_GROUP_CONFLICT,
  CURRENT_USER_CREATE_GROUP_SUCCESS,
  CURRENT_USER_CREATE_GROUP_ERROR,
  DELETE_GROUP_ERROR,
  DELETE_GROUP_SUCCESS,
  FILTER_GROUPS,
  GROUPS_STAGE_STUDENT_SUCCESS,
  GROUPS_STAGE_STUDENT_ERROR,
  GROUPS_UNDEFINED_STUDENT_RECORD,
  GROUPS_STUDENT_ALREADY_STAGED,
  LOAD_GROUPS_SUCCESS,
  STUDENT_TRANSACTION_ERROR_GROUP_CREATION,
  STUDENT_TRANSACTION_ERROR_UNDO,
  STUDENT_UNDO_GROUP_SUCCESS,
  UNDELETE_GROUP_ERROR,
  UNLOAD_GROUPS_SUCCESS,
  UPDATE_GROUP_ERROR,
  UPDATE_GROUP_SUCCESS
} from './action-types'

export function currentUserRejectGroup(group) {
  return (dispatch, getState) => {
    // get all the current user's information
    const auth = getAuth(getState())

    //=============================
    // TRANSACTION TO UPDATE GROUP OBJECT
    //=============================
    return firebaseDb.ref(`groups/${group.key}`)
      .transaction((groupRecord) => {
        if (groupRecord) {
          const currentInviteStatus = groupRecord.memberRecords[auth.id].inviteStatus
          if (currentInviteStatus === "PENDING") {
            groupRecord.memberRecords[auth.id].inviteStatus = "REJECTED"
            groupRecord.numRejects += 1
            groupRecord.isDisbanded = true
            dispatch({type:"CURRENT_USER_REJECT"})
            return groupRecord
          } else {
            console.log("Already responded");
            dispatch({type:"CURRENT_USER_ALREADY_RESPONDED"})
            return; //Abort the transaction
          }
        }
        return groupRecord
      })
      .then((result) => {
        if (result.committed) {

          const groupRecord = result.snapshot.val()

          if (groupRecord.isDisbanded) {
            // transactionally update all the memberRecords
            const memberRecords = new Map(groupRecord.memberRecords)

            memberRecords.forEach((member) => {
              firebaseDb.ref(`rhodes-students/${member.key}`)
                .transaction((studentRecord) => {
                  if (studentRecord) {
                    studentRecord.isInPendingGroup = false
                    studentRecord.isInConfirmedGroup = false
                    studentRecord.groupId = null
                    studentRecord.groupLotteryNumber = null
                    studentRecord.isGroupLeader = false
                    return studentRecord
                  }
                  return studentRecord
                })
                .then((result) => {})
                .catch((error) => {})

            })
          }


        }

      })
      .catch((error) => {})
  }
}

export function currentUserAcceptGroup(group) {
  return (dispatch, getState) => {
    // get all the current user's information
    const auth = getAuth(getState())

    //=============================
    // TRANSACTION TO UPDATE GROUP OBJECT
    //=============================
    return firebaseDb.ref(`groups/${group.key}`)
      .transaction((groupRecord) => {
        if (groupRecord) {
          const currentInviteStatus = groupRecord.memberRecords[auth.id].inviteStatus
          if (currentInviteStatus === "PENDING") {
            groupRecord.memberRecords[auth.id].inviteStatus = "ACCEPTED"
            groupRecord.numAccepts += 1

            if (groupRecord.groupSize === groupRecord.numAccepts) {
              groupRecord.isConfirmed = true
            }
            dispatch({type:"CURRENT_USER_ACCEPT"})
            return groupRecord
          } else {
            console.log("Already responded");
            dispatch({type:"CURRENT_USER_ALREADY_RESPONDED"})
            return; //Abort the transaction
          }
        }
        return groupRecord
      })
      .then((result) => {
        if (result.committed) {

          const groupRecord = result.snapshot.val()
          const groupRecordKey = result.snapshot.key

          if (groupRecord.isConfirmed) {
            // transactionally update all the memberRecords
            const memberRecords = new Map(groupRecord.memberRecords)

            memberRecords.forEach((member) => {
              firebaseDb.ref(`rhodes-students/${member.key}`)
                .transaction((studentRecord) => {
                  if (studentRecord) {
                    studentRecord.isInPendingGroup = false
                    studentRecord.isInConfirmedGroup = true
                    return studentRecord
                  }
                  return studentRecord
                })
                .then((result) => {})
                .catch((error) => {})

            })
            firebaseDb.ref(`confirmed-groups/${groupRecordKey}`)
              .set(groupRecord, error => error ? console.log(error) : null);
          }


        }

      })
      .catch((error) => {})
  }
}
export function currentUserCreateSingleGroup() {
  return (dispatch, getState) => {
    // get all the current user's information
    const auth = getAuth(getState())

    // request a key for a new firebase group object
    const newGroupKey = firebaseDb.ref('groups').push().key
    // empty structures to hold all the new group information
    let newGroupFirebaseRecord = {}
    let memberRecords = {}

    //=============================
    // START TRANSACTION TO READ/UPDATE STUDENT RECORD
    //=============================
    return firebaseDb.ref(`rhodes-students/${auth.key}`)
      .transaction((studentRecord) => {
        if (studentRecord) {
          if (studentRecord.groupId || studentRecord.isInPendingGroup || studentRecord.isInConfirmedGroup) {
            dispatch(createSingleGroupConflict())
            return; // Abort the transaction
          } else {
            // update the student record
            studentRecord.groupId = newGroupKey
            studentRecord.isInPendingGroup = false
            // Also update the student record to isInConfirmedGroup
            studentRecord.isInConfirmedGroup = true
            studentRecord.isGroupLeader = true
            studentRecord.groupLotteryNumber = auth.individualLotteryNumber

            // AND create the group
            //=============================
            // COPY USER INFORMATION TO STORE IN GROUP OBJECT
            //=============================
            let studentRecordCopy = { ...studentRecord }
            delete studentRecordCopy.groupId
            delete studentRecordCopy.isInPendingGroup
            delete studentRecordCopy.isInConfirmedGroup
            delete studentRecordCopy.isGroupLeader

            studentRecordCopy.key = auth.key
            studentRecordCopy.isCreator = true
            studentRecordCopy.isLeader = true
            studentRecordCopy.inviteStatus = "ACCEPTED"
            memberRecords[auth.id] = studentRecordCopy

            //=============================
            // SETUP NEW GROUP OBJECT
            //=============================
            newGroupFirebaseRecord[newGroupKey] = {
              [auth.id]: true,
              numAccepts: 1,
              numRejects: 0,
              isConfirmed: true,
              creatorEmail: auth.email,
              leaderEmail: auth.email,
              groupSize: 1,
              memberRecords: memberRecords,
              groupLotteryNumber: auth.individualLotteryNumber,
              hasSubmittedPreferences: false,
              multiYearGroup: false
            }
            groupList.update('', newGroupFirebaseRecord)
              .then(() => {
                dispatch(currentUserCreateGroupSuccess())
                firebaseDb.ref(`confirmed-groups/${newGroupKey}`)
                  .set(newGroupFirebaseRecord[newGroupKey], error => error ? console.log(error) : null);
                return studentRecord // changes get saved
              })
              .catch((error) => {
                dispatch(currentUserCreateGroupError(error))
                // Abort transaction because
                // error while creating group
                return;
              })
          }
        }
        return studentRecord
      })

  }
}

export function currentUserCreateGroup() {
  return (dispatch, getState) => {
    // get all the current user's information
    const auth = getAuth(getState())
    const readStudentRecordList = getStudentsStagedForInvite(getState())
    //=============================
    // COPY CREATOR INFORMATION TO STORE IN GROUP OBJECT
    //=============================
    let authCopy = auth.toObject()
    delete authCopy.existsInFirebase
    delete authCopy.authenticated
    delete authCopy.groupId
    delete authCopy.isInPendingGroup
    delete authCopy.isInConfirmedGroup
    delete authCopy.isGroupLeader
    authCopy.isCreator = true
    authCopy.isLeader = true
    authCopy.inviteStatus = "ACCEPTED"

    // Add to student list
    const allMembersList = readStudentRecordList.push(authCopy)

    // initialize yearLottoMap
    let yearLottoMap = new Map({2017:new List(), 2018:new List() , 2019:new List() , 2020:new List()})

    // Calculate group lottery number
    let groupLotteryNumber = 3000000
    allMembersList.forEach((member) => {

      let fullStr = member.individualLotteryNumber.toString()
      let fullStrLen = fullStr.length
      let yearStr = fullStr.substr(0,4)
      let lottoStr = fullStr.substr(4, fullStrLen)
      let lottoNum = Number(lottoStr)
      let updatedList
      switch (yearStr) {
        case "2017":
          updatedList = yearLottoMap.get('2017').push(lottoNum)
          yearLottoMap = yearLottoMap.set('2017', updatedList)
          break;
        case "2018":
          updatedList = yearLottoMap.get('2018').push(lottoNum)
          yearLottoMap = yearLottoMap.set('2018', updatedList)
          break;
        case "2019":
          updatedList = yearLottoMap.get('2019').push(lottoNum)
          yearLottoMap = yearLottoMap.set('2019', updatedList)
          break;
        case "2020":
          updatedList = yearLottoMap.get('2020').push(lottoNum)
          yearLottoMap = yearLottoMap.set('2020', updatedList)
          break;
        default:
          break;
      }

      // if (member.individualLotteryNumber < groupLotteryNumber) {
      //   groupLotteryNumber = member.individualLotteryNumber
      // }
    })
    // find the most senior list of lotto numbers
    let mostSeniorYear = ''
    let groupHasMultiYears = false
    if (yearLottoMap.get('2017').size > 0) {
      mostSeniorYear === '' ? mostSeniorYear = '2017' : null
    }
    if (yearLottoMap.get('2018').size > 0) {
      mostSeniorYear === '' ? mostSeniorYear = '2018' : groupHasMultiYears = true
    }
    if (yearLottoMap.get('2019').size > 0) {
      mostSeniorYear === '' ? mostSeniorYear = '2019' : groupHasMultiYears = true
    }
    if (yearLottoMap.get('2020').size > 0) {
      mostSeniorYear === '' ? mostSeniorYear = '2020' : groupHasMultiYears = true
    }

    const mostSeniorLottoList = yearLottoMap.get(mostSeniorYear).sort((a, b) => {
      if (a < b) { return -1; }
      if (a > b) { return 1; }
      if (a === b) { return 0; }
    })
    const finalLottoStr = `${mostSeniorYear}${mostSeniorLottoList.get(0)}`
    const finalLottoNum = Number(finalLottoStr)
    groupLotteryNumber = finalLottoNum


    // request a key for a new firebase group object
    const newGroupKey = firebaseDb.ref('groups').push().key

    // empty structures to hold all the new group information
    let newGroupFirebaseRecord = {}
    let memberRecords = {}
    //=============================
    // FOR EACH STUDENT RECORD
    // PERFORME READ/UPDATE TRANSACTION
    //=============================
    const studentListLength = allMembersList.size
    let studentIterator = 0
    let isConflict = false
    // Start loop
    allMembersList.forEach((studentObj) => {
      //=============================
      // START TRANSACTION TO READ/UPDATE STUDENT RECORD
      //=============================
      firebaseDb.ref(`rhodes-students/${studentObj.key}`)
        .transaction((studentRecord) => {
          if (studentRecord) {
            if (studentRecord.groupId || studentRecord.isInPendingGroup || studentRecord.isInConfirmedGroup) {
              return; // Abort the transaction
            } else {
              // update the student record
              studentRecord.groupId = newGroupKey
              studentRecord.isInPendingGroup = true
              studentRecord.groupLotteryNumber = groupLotteryNumber
              if (studentRecord.id === auth.id) {
                studentRecord.isGroupLeader = true
              }
              return studentRecord // saves the changes
            }
          }
          return studentRecord
        }).then((result) => {
          // increment our iterator counter
          studentIterator += 1
          if (!result.committed) {
            isConflict = true
            dispatch(createGroupConflict({...result.snapshot.val(), key: result.snapshot.key}))
          } else {

            const snapshot = result.snapshot
            const studentRecordKey = snapshot.key
            const studentRecord = snapshot.val()
            studentRecord.key = studentRecordKey
            // build the raw group data
            let prev = newGroupFirebaseRecord[newGroupKey]
            newGroupFirebaseRecord[newGroupKey] = {
              ...prev,
              [studentRecord.id]: true
            }
            studentRecord.isCreator = studentRecord.id === auth.id ? true : false
            studentRecord.isLeader = studentRecord.id === auth.id ? true : false
            studentRecord.inviteStatus = studentRecord.id === auth.id ? "ACCEPTED" : "PENDING"
            delete studentRecord.groupId
            delete studentRecord.isInPendingGroup
            delete studentRecord.isInConfirmedGroup
            delete studentRecord.isGroupLeader
            delete studentRecord.groupLotteryNumber
            memberRecords[studentRecord.id] = studentRecord

            if (studentIterator === studentListLength && !isConflict) {

              // create group - firebase call
              let prev = newGroupFirebaseRecord[newGroupKey]
              newGroupFirebaseRecord[newGroupKey] = {
                ...prev,
                [auth.id]: true,
                numAccepts: 1,
                numRejects: 0,
                isConfirmed: false,
                creatorEmail: auth.email,
                leaderEmail: auth.email,
                groupSize: allMembersList.size,
                groupLotteryNumber: groupLotteryNumber,
                memberRecords: memberRecords,
                hasSubmittedPreferences: false,
                multiYearGroup: groupHasMultiYears
              }
              groupList.update('', newGroupFirebaseRecord)
                .then(() => dispatch(currentUserCreateGroupSuccess()))
                .catch((error) => dispatch(currentUserCreateGroupError(error)))
            } else if (isConflict) {
              // transactions to free up students
              // we only change groupId and isInPendingGroup if groupId was previously null
              // Therefore if the student's groupId is equal to newGroupKey,
              // change the groupId to null and change isInPendingGroup to false
              allMembersList.forEach((studentObj) => {
                firebaseDb.ref(`rhodes-students/${studentObj.key}`)
                  .transaction((studentRecord) => {
                    if (studentRecord) {
                      if (studentRecord.groupId === newGroupKey) {
                        studentRecord.groupId = null
                        studentRecord.groupLotteryNumber = null
                        studentRecord.isInPendingGroup = false
                        studentRecord.isGroupLeader = false
                      } else {
                        return; // Abort transaction because record does not need to be changed
                      }
                      return studentRecord
                    }
                    return studentRecord
                  })
                  .then((result) => {
                    if (result.committed) {
                      dispatch(studentUndoGroupSuccess({...result.snapshot.val(), key: snapshot.key }))
                    }
                  })
                  .catch((error) => dispatch(studentTransactionError(STUDENT_TRANSACTION_ERROR_UNDO, error)))
              })
            }

            // else keep going
          }
        })
        .catch((error) => dispatch(studentTransactionError(STUDENT_TRANSACTION_ERROR_GROUP_CREATION, error)))
    })

  }
}

export function currentUserCreateGroupSuccess() {
  return {
    type: CURRENT_USER_CREATE_GROUP_SUCCESS
  }
}

export function currentUserCreateGroupError(error) {
  return {
    type: CURRENT_USER_CREATE_GROUP_ERROR,
    payload: error
  }
}

export function createSingleGroupConflict() {
  return {
    type: CREATE_SINGLE_GROUP_CONFLICT
  }
}

export function createGroupConflict(studentRecord) {
  return {
    type: CREATE_GROUP_CONFLICT,
    payload: studentRecord
  }
}

export function studentUndoGroupSuccess(studentRecord) {
  return {
    type: STUDENT_UNDO_GROUP_SUCCESS,
    payload: studentRecord
  }
}
//=============================
// SIDE EFFECT ACTION CREATORS
//=============================
export function loadRecordUpdateState(email) {
  return (dispatch, getState) => {
    return dispatch(loadStudentRecordForUserByEmail(email))
      .then((value) => {
        if (value === undefined) {
          dispatch(groupsUndefinedStudentRecord())
        }
        // The student has not been staged for an invite
        else if (getStudentsStagedForInviteByEmail(getState(), email) === null) {
          dispatch(groupsStageStudentRecordSuccess(value))

        }
        else {
          dispatch(groupsStudentAlreadyStaged(value))
        }
      })
      .catch((error) => {
        dispatch(groupsStageStudentRecordError(error))
      })
  }
}

export function loadStudentRecordForUserByEmail(email) {
  return (dispatch, getState) => {
    const pathToStudentDB = 'rhodes-students'
    const lookUp = {
      queryChild: "email",
      queryString: email,
      lookUpType: "equalTo"
    }
    return new Promise((resolve, reject) => {
      firebaseDb.ref(pathToStudentDB)
        .orderByChild(lookUp.queryChild)
        .equalTo(lookUp.queryString)
        .once('value', (snapshot) => {
          let value
          snapshot.forEach((snap) => {
            value = snap.val()
            value.key = snap.key
            return true
          })
          resolve(value)
        },
        (error) => {
          reject(error)
        })
    })
  }
}

export function groupsUndefinedStudentRecord() {
  return {
    type: GROUPS_UNDEFINED_STUDENT_RECORD,
    payload: null
  }
}

export function groupsStudentAlreadyStaged(student) {
  return {
    type: GROUPS_STUDENT_ALREADY_STAGED,
    payload: student
  }
}

export function groupsStageStudentRecordSuccess(student) {
  return {
    type: GROUPS_STAGE_STUDENT_SUCCESS,
    payload: student
  }
}

export function groupsStageStudentRecordError(error) {
  return {
    type: GROUPS_STAGE_STUDENT_ERROR,
    payload: error
  }
}

export function studentTransactionError(type, error) {
  return {
    type: type,
    payload: error
  }
}
//=============================
// CORE ACTION CREATORS
//=============================
export function createGroupError(error) {
  return {
    type: CREATE_GROUP_ERROR,
    payload: error
  };
}

export function createGroupSuccess(group) {
  return {
    type: CREATE_GROUP_SUCCESS,
    payload: group
  };
}

export function deleteGroup(group) {
  return dispatch => {
    return groupList.remove(group.key)
      .catch(error => dispatch(deleteGroupError(error)));
  };
}

export function deleteGroupError(error) {
  return {
    type: DELETE_GROUP_ERROR,
    payload: error
  };
}

export function deleteGroupSuccess(group) {
  return {
    type: DELETE_GROUP_SUCCESS,
    payload: group
  };
}

// would need modification to work properly
export function undeleteGroup() {
  return (dispatch, getState) => {
    const group = getDeletedGroup(getState());
    if (group) {
      return groupList.set(group.key, {completed: group.completed, title: group.title})
        .catch(error => dispatch(undeleteGroupError(error)));
    }
    return Promise.resolve()
  };
}

export function undeleteGroupError(error) {
  return {
    type: UNDELETE_GROUP_ERROR,
    payload: error
  };
}

export function updateGroupError(error) {
  return {
    type: UPDATE_GROUP_ERROR,
    payload: error
  };
}

export function updateGroup(group, changes) {
  return dispatch => {
    return groupList.update(group.key, changes)
      .catch(error => dispatch(updateGroupError(error)));
  };
}

export function updateGroupSuccess(group) {
  return {
    type: UPDATE_GROUP_SUCCESS,
    payload: group
  };
}

export function loadGroupsSuccess(groups) {
  return {
    type: LOAD_GROUPS_SUCCESS,
    payload: groups
  };
}

export function filterGroups(filterType) {
  return {
    type: FILTER_GROUPS,
    payload: {filterType}
  };
}

export function loadGroups() {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    groupList.path = `groups`;
    const lookUp = {
      queryChild: auth.id,
      queryString: true,
      lookUpType: "equalTo"
    }
    groupList.subscribe(dispatch, lookUp);
    return Promise.resolve()
  };
}


export function unloadGroups() {
  groupList.unsubscribe();
  return {
    type: UNLOAD_GROUPS_SUCCESS
  };
}



// WEBPACK FOOTER //
// ./src/core/groups/actions.js